<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><span class="big"><strong>Just<br/> <em>the Right</em><br/> WORDS</strong></span></p>
<p class="center"><strong>JUDITH WIBBERLEY</strong><br/><br/><br/><br/><br/><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/logo.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?64ac7e5c